import { Select } from 'antd'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify'
import { useGetServiceCategoriesQuery } from '../redux/apis/servicesManagement/sMServicesCategoriesApiSlice'

const ServiceCategoriesDropdown = ({ onChange, onBlur, value, disabled, className }) => {
  const { data, isLoading, error } = useGetServiceCategoriesQuery({
    fields: ['id', 'category_name'],
    page: '*'
  })

  useEffect(() => {
    if (!error && !isLoading) {
      return
    }
    toast.error(error)
  }, [error, isLoading])

  return (
    <div className=' mb-3 flex-1'>
      <label className="form-label">Service Category</label>
      <br />
      <Select
        className={className}
        name='service'
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={data?.data?.results?.map(x => {
          return { label: x.category_name, value: x.id }
        })}
        disabled={disabled}
      />
    </div>
  )
}

export default ServiceCategoriesDropdown
